//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'cc239',
    colors: ['#e3dd34', '#78496b', '#f0527f', '#a7e0e2'],
    background: '#e0eff0',
    type: 'colourscafe',
  },
  {
    name: 'cc234',
    colors: ['#ffce49', '#ede8dc', '#ff5736', '#ff99b4'],
    background: '#f7f4ed',
    type: 'colourscafe',
  },
  {
    name: 'cc232',
    colors: ['#5c5f46', '#ff7044', '#ffce39', '#66aeaa'],
    background: '#e9ecde',
    type: 'colourscafe',
  },
  {
    name: 'cc238',
    colors: ['#553c60', '#ffb0a0', '#ff6749', '#fbe090'],
    background: '#f5e9de',
    type: 'colourscafe',
  },
  {
    name: 'cc242',
    colors: ['#bbd444', '#fcd744', '#fa7b53', '#423c6f'],
    background: '#faf4e4',
    type: 'colourscafe',
  },
  {
    name: 'cc245',
    colors: ['#0d4a4e', '#ff947b', '#ead3a2', '#5284ab'],
    background: '#f6f4ed',
    type: 'colourscafe',
  },
  {
    name: 'cc273',
    colors: ['#363d4a', '#7b8a56', '#ff9369', '#f4c172'],
    background: '#f0efe2',
    type: 'colourscafe',
  },
];
